export enum StackingMethod {
  DUPLICATE = 'duplicate',
  ROTATE = 'rotate',
  MIRROR_VERT = 'mirrorVert',
  MIRROR_HORIZ = 'mirrorHoriz',
  CUSTOMIZED = 'customized',
}
